import script from "./BlockListChips.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlockListChips.vue?vue&type=script&lang=ts&setup=true"

import "./BlockListChips.vue?vue&type=style&index=0&id=3b2bc9cf&lang=sass"

const __exports__ = script;

export default __exports__